/* eslint-disable */
import {
  // Button,
  makeStyles,
  TableBody,
  TableCell,
  TableFooter,
  TableRow
} from "@material-ui/core";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TableHead from "@saleor/components/TableHead";
import TablePagination from "@saleor/components/TablePagination";
import { emailSettingsList_emailSettings_edges_node } from "@saleor/emailTemplate/types/emailSettingsList";
import { renderCollection } from "@saleor/misc";
import { RotaryListUrlSortField } from "@saleor/rotary/urls";
import { ListActions, ListProps, SortPage } from "@saleor/types";
// import { getArrowDirection } from "@saleor/utils/sort";
import moment from "moment-timezone";
import React from "react";
import { FormattedMessage } from "react-intl";

export interface RotaryListProps
  extends ListProps,
    ListActions,
    SortPage<RotaryListUrlSortField> {
  emailSettings: emailSettingsList_emailSettings_edges_node[];
}

const numberOfColumns = 6;
const useStyles = makeStyles(
  theme => ({
    [theme.breakpoints.up("lg")]: {
      colName: {
        width: "33%"
      }
    }
  }),
  { name: "RotaryList" }
);

const EmailTemplateList: React.FC<RotaryListProps> = ({
  emailSettings,
  disabled,
  isChecked,
  onNextPage,
  onPreviousPage,
  onRowClick,
  pageInfo,
  selected,
  // sort,
  toggle,
  toggleAll,
  toolbar
  // onSort,
}) => {
  const classes = useStyles({});
  return (
    <ResponsiveTable>
      <TableHead
        colSpan={numberOfColumns}
        selected={selected}
        disabled={disabled}
        items={emailSettings}
        toggleAll={toggleAll}
        toolbar={toolbar}
      >
        <TableCellHeader
          className={classes.colName}
          // direction={
          //   sort.sort === RotaryListUrlSortField.name
          //     ? getArrowDirection(sort.asc)
          //     : undefined
          // }
          // onClick={() => onSort(RotaryListUrlSortField.name)}
        >
          <FormattedMessage defaultMessage="Template Name" />
        </TableCellHeader>
        <TableCellHeader
          className={classes.colName}
          // direction={
          //   sort.sort === RotaryListUrlSortField.number
          //     ? getArrowDirection(sort.asc)
          //     : undefined
          // }
          // onClick={() => onSort(RotaryListUrlSortField.number)}
        >
          <FormattedMessage defaultMessage="Description" />
        </TableCellHeader>
        <TableCellHeader
          className={classes.colName}
          // direction={
          //   sort.sort === RotaryListUrlSortField.endDate
          //     ? getArrowDirection(sort.asc)
          //     : undefined
          // }
          // onClick={() => onSort(RotaryListUrlSortField.endDate)}
        >
          <FormattedMessage defaultMessage="Update Time" />
        </TableCellHeader>
      </TableHead>
      <TableFooter>
        <TableRow>
          <TablePagination
            colSpan={numberOfColumns}
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            onNextPage={onNextPage}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onPreviousPage={onPreviousPage}
          />
        </TableRow>
      </TableFooter>
      <TableBody>
        {renderCollection(
          emailSettings,
          arotary => {
            const isSelected = arotary ? isChecked(arotary.id) : false;
            return (
              <TableRow
                selected={isSelected}
                hover={!!arotary}
                key={arotary ? arotary.id : "skeleton"}
                onClick={arotary && onRowClick(arotary.id)}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isSelected}
                    disabled={disabled}
                    disableClickPropagation
                    onChange={() => toggle(arotary.id)}
                  />
                </TableCell>
                <TableCell className={classes.colName}>
                  {arotary ? arotary.name : <Skeleton />}
                </TableCell>
                <TableCell className={classes.colName}>
                  {arotary ? arotary.description : <Skeleton />}
                </TableCell>
                <TableCell className={classes.colName}>
                  {arotary ? (
                    arotary.lastChange ? (
                      moment(arotary.lastChange).format("YYYY-MM-DD HH:mm:ss")
                    ) : (
                      ""
                    )
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
              </TableRow>
            );
          },
          () => (
            <TableRow>
              <TableCell colSpan={numberOfColumns}>
                <FormattedMessage defaultMessage="No rotary found" />
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </ResponsiveTable>
  );
};

export default EmailTemplateList;
